// Persistência do "o que mudou / what's new" já visto, por VERSÃO. Diferente do
// welcome-storage (uma chave por módulo), aqui a chave carrega a versão do
// conteúdo: subir a versão (nova mudança de design) reabre o tour para todos,
// sem apagar nada.
//
// A chave é do NAVEGADOR, não do profissional: o anúncio de redesign é o mesmo
// para todo mundo, e carimbá-lo por usuário faria a mesma máquina reexibir o
// tour a cada troca de login — o oposto do que se quer.
//
// Cada acesso a localStorage é resiliente (try/catch): em modo privado/quota
// cheia o acesso pode lançar — nesse caso logamos e degradamos (tour reaparece
// no próximo reload), como faz o irmão floating-dock-state.js.

const isValidVersion = (version) =>
  version !== undefined && version !== null && version !== ''

const seenKeyPrefix = (moduleKey) =>
  `aawz_whatsnew_seen_${moduleKey}_v`

export const whatsnewSeenKey = (moduleKey, version) =>
  `${seenKeyPrefix(moduleKey)}${version}`

export const isWhatsnewSeen = (moduleKey, version) => {
  if (!moduleKey || !isValidVersion(version)) return false
  try {
    return localStorage.getItem(whatsnewSeenKey(moduleKey, version)) === 'true'
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Whatsnew: falha ao ler estado no localStorage', e)
    return false
  }
}

export const setWhatsnewSeen = (moduleKey, version, value = true) => {
  if (!moduleKey || !isValidVersion(version)) return
  const currentKey = whatsnewSeenKey(moduleKey, version)
  try {
    localStorage.setItem(currentKey, value ? 'true' : 'false')
    pruneOldVersions(moduleKey, currentKey)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Whatsnew: falha ao salvar estado no localStorage', e)
  }
}

// Remove chaves de versões anteriores do MESMO módulo, mantendo só a chave
// atual — evita crescimento ilimitado de `aawz_whatsnew_seen_*` a cada bump de
// versão. Falha de acesso é silenciada (a escrita principal já aconteceu).
//
// Só alcança o mesmo moduleKey: as chaves dos moduleKeys aposentados (`crm`,
// `compliance`, `consolidator_overview`, ...) e as do formato antigo, que
// terminavam no id do profissional, ficam órfãs — inertes, ~40 bytes cada.
// Limpá-las exigiria varrer o prefixo `aawz_whatsnew_seen_` inteiro.
const pruneOldVersions = (moduleKey, currentKey) => {
  const prefix = seenKeyPrefix(moduleKey)
  try {
    const stale = []
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i)
      if (!key || key === currentKey) continue
      if (key.startsWith(prefix)) stale.push(key)
    }
    stale.forEach((key) => localStorage.removeItem(key))
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Whatsnew: falha ao podar versões antigas no localStorage', e)
  }
}
